import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const OwnersDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment OwnersDisplayGridRowDataFragment on TableauUser {
  id
  name
  username
  domain
  vizportalId
  ownedWorkbooksConnection {
    totalCount
  }
  ownedDatasourcesConnection {
    totalCount
  }
  ownedMetricsConnection {
    totalCount
  }
  ownedVirtualConnectionsConnection {
      totalCount
  }
}
`;
